import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App.jsx";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "@/data/store";
import { initTokenFactory } from "@/lib/tokenFactory";
import { ThemeProvider } from "next-themes";
import { initI18n } from "./lib/i18n";
import Loading from "@/components/common/Loading";
import { loadEnv } from "@/lib/env";

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <Loading />
    </ThemeProvider>
  </StrictMode>,
);

async function bootstrap() {
  initTokenFactory(store); // ✅ inject store after it is created
  await loadEnv();
  await initI18n(); // populates Redux + i18next
  root.render(
    <StrictMode>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
        <Provider store={store}>
          <PersistGate loading={<Loading />} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </StrictMode>,
  );
}

bootstrap();
